const NAMESPACE = 'PRODUCTS';
export const CLEAR_ITEMS = `${NAMESPACE}_CLEAR_ITEMS`;
export const FETCH_ITEMS = `${NAMESPACE}_FETCH_ITEMS`;
export const FETCH_ITEM = `${NAMESPACE}_FETCH_ITEM`;
export const UPDATE_ITEM = `${NAMESPACE}_UPDATE_ITEM`;
export const ADD_ITEM = `${NAMESPACE}_ADD_ITEM`;
export const DELETE_ITEM = `${NAMESPACE}_DELETE_ITEM`;
export const UPDATE_INVENTORY = `${NAMESPACE}_UPDATE_INVENTORY`;
export const BULK_UPDATE_INVENTORY = `${NAMESPACE}_BULK_UPDATE_INVENTORY`;

export const MATCHES_PENDING_STATUS = 'pending';
export const MATCHES_ARCHIVED_STATUS = 'archived';
export const MATCHES_CONNECTED_STATUS = 'connected';
export const ECOMMERCE_INTEGRATION_ACTION = 'ecommerceIntegration';

export const INVENTORY_ACTIONS = [
  {
    label: 'New Inventory',
    value: 'newInventory',
  },
  {
    label: 'Ecommerce Integration',
    value: ECOMMERCE_INTEGRATION_ACTION,
  },
  {
    label: 'Damaged',
    value: 'damaged',
  },
  {
    label: 'Stock Taking',
    value: 'stockTaking',
  },
  {
    label: 'Returned',
    value: 'returned',
  },
  {
    label: 'Retail',
    value: 'retail',
  },
  {
    label: 'Backbar',
    value: 'backbar',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
